import { z } from 'zod';

import { optionalString, requiredString } from '@/shared/utils/validation';

export const createUpdateRoleInputSchema = (isGroupRequired = false) =>
  z.object({
    name: requiredString(),
    description: optionalString(),
    ssoGroupMapping: z.array(requiredString()).optional(),
    groupId: isGroupRequired ? requiredString() : optionalString(),
  });
